import React from 'react'

function GridIcon({ color = 'currentColor', size = 20, ...rest }) {
    return (
        <svg {...rest} width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M21.333 21.334H26.6663V26.6673H21.333V21.334ZM13.333 21.334H18.6663V26.6673H13.333V21.334ZM5.33301 21.334H10.6663V26.6673H5.33301V21.334ZM21.333 13.334H26.6663V18.6673H21.333V13.334ZM13.333 13.334H18.6663V18.6673H13.333V13.334ZM5.33301 13.334H10.6663V18.6673H5.33301V13.334ZM21.333 5.33398H26.6663V10.6673H21.333V5.33398ZM13.333 5.33398H18.6663V10.6673H13.333V5.33398ZM5.33301 5.33398H10.6663V10.6673H5.33301V5.33398Z" fill={color} />
        </svg>

    )
}

export default GridIcon
